import Footer from '../Components/Shared/Footer';
import { Outlet } from 'react-router-dom';
import NavbarConfiguration from '../Components/Shared/Navbars/NavbarConfiguration';

const ConfigurationLayout = () => {
    return (
        <div className="background-banner container-main-router">
            <NavbarConfiguration />
            <main className='container-fluid'>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}

export default ConfigurationLayout;
